export const ONYX_ICONS = {
  Menu: [
    'menu-orders-outlined',
    'menu-orders-filled',
    'menu-fleet-outlined',
    'menu-fleet-filled',
    'menu-drivers-outlined',
    'menu-drivers-filled',
    'menu-more-outlined',
    'menu-repairs-outlined',
    'menu-repairs-filled',
    'menu-delegations-outlined',
    'menu-delegations-filled',
    'menu-control-panel-outlined',
    'menu-control-panel-filled',
    'menu-map-outlined',
    'menu-map-filled',
    'menu-business-outlined',
    'menu-business-filled',
    'menu-documents-outlined',
    'menu-documents-filled',
    'menu-integrations-outlined',
    'menu-integrations-filled',
    'menu-poi-outlined',
    'menu-poi-filled',
    'menu-contractors-outlined',
    'menu-contractors-filled',
    'menu-dictionaries-outlined',
    'menu-dictionaries-filled',
    'menu-password-outlined',
    'menu-password-filled',
    'menu-engine-outlined',
    'menu-engine-filled',
    'menu-user-data-outlined',
    'menu-user-data-filled',
    'menu-bases-outlined',
    'menu-bases-filled',
    'menu-employees-outlined',
    'menu-employees-filled',
    'menu-gantt-outlined',
    'menu-gantt-filled',
    'menu-logout-outlined',
    'menu-help-outlined',
    'menu-help-filled',
    'menu-fuel-policy-outlined',
    'menu-fuel-policy-filled',
    'menu-road-settings-outlined',
    'menu-road-settings-filled',
  ],

  View: [
    'list-view-filled',
    'column-view-outlined',
    'column-view-filled',
    'calendar-view-outlined',
    'calendar-view-filled',
    'map-view-outlined',
    'map-view-filled',
    'dark-mode-outlined',
    'dark-mode-filled',
    'light-mode-outlined',
    'light-mode-filled',
    'plus-circle-outlined',
    'plus-circle-filled',
    'minus-circle-outlined',
    'minus-circle-filled',
    'gantt-outlined',
    'gantt-filled',
  ],

  System: [
    'options-horizontal-filled',
    'options-vertical-filled',
    'settings-filled',
    'search-outlined',
    'views-outlined',
    'views-filled',
    'drag-horizontal-filled',
    'drag-vertical-filled',
    'verified-filled',
    'check-circle-outlined',
    'check-circle-filled',
    'check-outlined',
    'side-modal-filled',
    'home-outlined',
    'home-filled',
    'contractor-outlined',
    'contractor-filled',
    'visibility-shown-outlined',
    'visibility-shown-filled',
    'visibility-hidden-outlined',
    'visibility-hidden-filled',
    'coil-well-outlined',
    'coil-well-filled',
    'mark-as-read-outlined',
    'mark-as-read-filled',
    'tooltip-outlined',
    'tooltip-filled',
    'tooltip-two-tone-filled',
    'shield-outlined',
    'shield-filled',
    'scale-outlined',
    'scale-alt-outlined',
    'no-entry-outlined',
    'no-entry-filled',
    'print-outlined',
    'print-filled',
    'hashtag-filled',
    'exchange-filled',
    'no-results-outlined',
    'ai-outlined',
    'ai-filled',
    'placeholder-outlined',
    'bookmark-outlined',
    'bookmark-filled',
    'help-outlined',
    'help-filled',
    'finance-outlined',
    'finance-filled',
    'finance-off-outlined',
    'offer-outlined',
    'offer-filled',
    'more-filled',
    'more-alt-filled',
    'locked-outlined',
    'locked-filled',
    'unlocked-outlined',
    'unlocked-filled',
    'integrations-outlined',
    'integrations-filled',
    'no-integration-outlined',
    'indeterminate-outlined',
    'translations-outlined',
    'manual-outlined',
    'manual-filled',
    'cursor-filled',
    'archives-outlined',
    'archives-filled',
    'new-order-outlined',
    'new-order-filled',
    'delegation-outlined',
    'delegation-filled',
    'decision-outlined',
    'decision-filled',
    'compass-right-outlined',
    'compass-right-filled',
    'integration-outlined',
    'rating-outlined',
    'rating-filled',
    'proposition-circle-outlined',
    'proposition-circle-filled',
    'article-outlined',
    'article-filled',
    'recycling-filled',
    'combined-view-outlined',
    'combined-view-filled',
    'bar-chart-filled',
    'service-outlined',
    'service-filled',
    'calculate-outlined',
    'calculate-filled',
  ],

  'Quick actions': [
    'refresh-outlined',
    'delete-outlined',
    'delete-filled',
    'close-outlined',
    'edit-outlined',
    'edit-filled',
    'copy-outlined',
    'copy-filled',
    'block-outlined',
    'block-filled',
    'clear-outlined',
    'clear-filled',
    'clear-two-tone-filled',
    'import-outlined',
    'export-outlined',
    'download-outlined',
    'upload-outlined',
    'forward-outlined',
    'forward-filled',
    'share-outlined',
    'share-filled',
    'add-outlined',
    'restart-outlined',
    'link-off-outlined',
  ],

  Users: [
    'user-outlined',
    'user-filled',
    'two-users-outlined',
    'two-users-filled',
    'group-outlined',
    'group-filled',
    'vacation-outlined',
    'vacation-filled',
    'sick-leave-outlined',
    'sick-leave-filled',
    'no-user-outlined',
    'no-user-filled',
  ],

  Arrows: [
    'arrow-right-outlined',
    'arrow-down-outlined',
    'arrow-left-outlined',
    'arrow-up-outlined',
    'arrow-alt-right-outlined',
    'arrow-alt-down-outlined',
    'arrow-alt-left-outlined',
    'arrow-alt-up-outlined',
    'arrow-double-right-outlined',
    'arrow-double-down-outlined',
    'arrow-double-left-outlined',
    'arrow-double-up-outlined',
    'arrow-triangle-right-outlined',
    'arrow-triangle-down-outlined',
    'arrow-triangle-left-outlined',
    'arrow-triangle-up-outlined',
    'arrow-timeline-filled',
    'expand-all-outlined',
    'collapse-all-outlined',
    'undo-outlined',
    'trend-down-filled',
    'trend-up-filled',
    'arrow-downward-outlined',
    'arrow-upward-outlined',
    'arrow-down-circle-filled',
    'arrow-right-circle-filled',
  ],

  Table: [
    'sort-outlined',
    'filters-outlined',
    'filters-filled',
    'list-outlined',
    'table-outlined',
    'table-filled',
    'filters-on-outlined',
    'filters-on-filled',
    'filters-off-outlined',
    'filters-off-filled',
  ],

  Time: [
    'clock-outlined',
    'clock-filled',
    'calendar-outlined',
    'calendar-filled',
    'calendar-alt-outlined',
    'calendar-alt-filled',
    'history-outlined',
    'date-end-outlined',
    'date-end-filled',
    'hourglass-top-filled',
  ],

  Map: [
    'localize-outlined',
    'localize-filled',
    'location-outlined',
    'location-filled',
    'zoom-in-outlined',
    'zoom-out-outlined',
    'maximize-outlined',
    'minimize-outlined',
    'layers-outlined',
    'layers-filled',
    'new-tab-outlined',
    'dynamic-outlined',
    'dynamic-filled',
    'static-outlined',
    'static-filled',
    'center-outlined',
  ],

  Transport: [
    'loading-outlined',
    'loading-filled', // filler
    'unloading-outlined',
    'unloading-filled', // filler
    'semi-trailer-standard-outlined',
    'semi-trailer-half-mega-outlined',
    'semi-trailer-mega-outlined',
    'empty-km-outlined',
    'empty-km-filled',
    'road-outlined',
    'road-filled',
    'compass-up-filled',
    'good-outlined',
    'good-filled',
    'ltl-outlined',
    'ftl-outlined',
    'weight-empty-outlined',
    'weight-half-outlined',
    'weight-filled',
    'speed-outlined',
    'speed-filled',
    'sent-filled',
    'safe-parking-filled',
    'ferry-train-outlined',
    'ferry-train-filled',
    'exclusive-outlined',
    'exclusive-filled',
    'fuel-barrel-filled',
  ],

  Places: [
    'customs-outlined',
    'customs-filled',
    'car-wash-outlined',
    'car-wash-filled',
    'gas-station-outlined',
    'gas-station-filled',
    'parking-filled',
    'other-outlined',
    'other-filled',
    'base-outlined',
    'base-filled',
    'correspondence-address-outlined',
    'correspondence-address-filled',
    'port-outlined',
    'port-filled', // filler
    'ferry-outlined',
    'ferry-filled',
    'airport-filled',
    'tunnel-filled',
    'route-outlined',
    'route-filled',
    'border-crossing-filled',
    'gas-station-circle-filled',
    'customs-circle-filled',
    'car-wash-circle-filled',
    'train-circle-filled',
    'other-circle-filled',
    'ferry-circle-filled',
    'parking-circle-filled',
  ],

  'Vehicle states': [
    'vehicle-free-outlined',
    'vehicle-free-dotted-outlined',
    'vehicle-ride-filled',
    'vehicle-disconnected-outlined',
    'vehicle-disconnected-filled',
    'vehicle-disconnected-circle-filled',
    'vehicle-unloading-outlined',
    'vehicle-unloading-filled',
    'vehicle-good-outlined',
    'vehicle-good-filled',
    'vehicle-loading-circle-filled',
    'vehicle-unloading-circle-filled',
    'vehicle-waiting-two-tone-filled',
    'vehicle-waiting-filled',
    'vehicle-waiting-alt-filled',
    'vehicle-waiting-alt-2-filled',
    'vehicle-off-route-filled',
    'vehicle-off-route-circle-filled',
    'vehicle-off-route-on-time-circle-filled',
    'vehicle-off-route-delay-risk-circle-filled',
    'vehicle-off-route-delayed-circle-filled',
    'vehicle-semi-trailer-free-filled',
    'vehicle-trailer-free-filled',
    'trailer-loaded-filled',
    'semi-trailer-loaded-filled',
  ],

  Vehicles: [
    'vehicle-outlined',
    'vehicle-filled',
    'semi-truck-outlined', // filler
    'semi-truck-filled',
    'straight-truck-outlined',
    'straight-truck-filled',
    'van-outlined',
    'van-filled',
    'semi-trailer-outlined',
    'semi-trailer-filled',
    'trailer-outlined',
    'trailer-filled',
    'steering-wheel-filled',
    'low-deck-filled',
    'train-outlined',
    'train-filled',
  ],

  Tacho: [
    'tacho-outlined',
    'tacho-ride-outlined',
    'tacho-other-work-outlined',
    'tacho-break-outlined',
    'tacho-availability-outlined',
    'tacho-offline-outlined',
    'tacho-range-outlined',
    'tacho-connection-waiting-outlined',
    'tacho-connection-waiting-neutral-outlined',
  ],

  Contact: [
    'email-outlined',
    'telephone-outlined',
    'telephone-filled',
    'envelope-outlined',
    'envelope-filled',
  ],

  Files: [
    'document-outlined',
    'document-filled',
    'documents-outlined',
    'documents-filled',
    'pdf-outlined',
    'attachment-outlined',
    'picture-outlined',
    'picture-filled',
    'note-outlined',
    'note-filled',
  ],

  Requirements: [
    'requirements-food-outlined',
    'requirements-adr-outlined',
    'requirements-adr-tank-outlined',
    'requirements-explosives-outlined',
    'requirements-didb-outlined',
    'requirements-forklift-outlined',
    'requirements-forklift-filled',
    'requirements-other-filled',
  ],

  Integrations: [
    'automatic-pairing-filled',
    'live-data-filled',
    'car-engine-filled',
    'fuel-level-filled',
    'adblue-level-filled',
    'mileage-filled',
    'fuel-consumption-filled',
    'amsl-filled',
    'next-service-filled',
    'total-weight-filled',
    'axle-weight-filled',
    'power-take-off-filled',
    'dtc-filled',
  ],

  Errors: [
    'error-outlined',
    'error-two-tone-outlined',
    'error-filled',
    'error-two-tone-filled',
    'error-circle-outlined',
    'error-circle-two-tone-outlined',
    'error-circle-filled',
    'error-circle-two-tone-filled',
    'alert-circle-outlined',
    'alert-circle-two-tone-outlined',
    'alert-circle-filled',
    'alert-circle-two-tone-filled',
    'alert-outlined',
    'alert-two-tone-outlined',
    'alert-filled',
    'alert-two-tone-filled',
    'error-neutral-outlined',
    'error-neutral-two-tone-outlined',
    'error-neutral-filled',
    'error-neutral-filled-two-tone-filled',
  ],

  'ADR Class': [
    'adr-1',
    'adr-2-1',
    'adr-2-2',
    'adr-2-3',
    'adr-3',
    'adr-4-1',
    'adr-4-2',
    'adr-4-3',
    'adr-5-1',
    'adr-5-2',
    'adr-6-1',
    'adr-6-2',
    'adr-7',
    'adr-8',
    'adr-9',
  ],

  Logo: ['signet', 'signet-light', 'signet-dark'],
} as const;

export const FLAGS = [
  'ad',
  'ae',
  'af',
  'ag',
  'ai',
  'al',
  'am',
  'an',
  'ao',
  'ar',
  'as',
  'at',
  'au',
  'aw',
  'az',
  'ba',
  'bb',
  'bd',
  'be',
  'bf',
  'bg',
  'bh',
  'bi',
  'bj',
  'bm',
  'bn',
  'bo',
  'br',
  'bs',
  'bt',
  'bw',
  'by',
  'bz',
  'ca',
  'cc',
  'cd',
  'cf',
  'cg',
  'ch',
  'ci',
  'ck',
  'cl',
  'cm',
  'cn',
  'co',
  'cr',
  'cu',
  'cv',
  'cw',
  'cx',
  'cy',
  'cz',
  'de',
  'dj',
  'dk',
  'dm',
  'do',
  'dz',
  'ec',
  'ee',
  'eg',
  'eh',
  'er',
  'es',
  'et',
  'eu',
  'fi',
  'fj',
  'fk',
  'fm',
  'fo',
  'fr',
  'ga',
  'gb',
  'gd',
  'ge',
  'gf',
  'gg',
  'gh',
  'gi',
  'gl',
  'gm',
  'gn',
  'gq',
  'gr',
  'gt',
  'gu',
  'gw',
  'gy',
  'hk',
  'hn',
  'hr',
  'ht',
  'hu',
  'id',
  'ie',
  'il',
  'im',
  'in',
  'iq',
  'ir',
  'is',
  'it',
  'je',
  'jm',
  'jo',
  'jp',
  'ke',
  'kg',
  'kh',
  'ki',
  'km',
  'kn',
  'kp',
  'kr',
  'kw',
  'ky',
  'kz',
  'la',
  'lb',
  'lc',
  'li',
  'lk',
  'lr',
  'ls',
  'lt',
  'lu',
  'lv',
  'ly',
  'ma',
  'mc',
  'md',
  'me',
  'mg',
  'mh',
  'mk',
  'ml',
  'mm',
  'mn',
  'mo',
  'mr',
  'ms',
  'mt',
  'mu',
  'mv',
  'mw',
  'mx',
  'my',
  'mz',
  'na',
  'nc',
  'ne',
  'nf',
  'ng',
  'ni',
  'nl',
  'no',
  'np',
  'nr',
  'nu',
  'nz',
  'om',
  'pa',
  'pe',
  'pf',
  'pg',
  'ph',
  'pk',
  'pl',
  'pn',
  'pr',
  'ps',
  'pt',
  'pw',
  'py',
  'qa',
  'ro',
  'rs',
  'ru',
  'rw',
  'sa',
  'sb',
  'sc',
  'sd',
  'se',
  'sg',
  'si',
  'sk',
  'sl',
  'sm',
  'sn',
  'so',
  'sr',
  'ss',
  'st',
  'sv',
  'sx',
  'sy',
  'sz',
  'tc',
  'td',
  'tg',
  'th',
  'tj',
  'tk',
  'tl',
  'tm',
  'tn',
  'to',
  'tr',
  'tt',
  'tv',
  'tw',
  'tz',
  'ua',
  'ug',
  'us',
  'uy',
  'uz',
  'va',
  'vc',
  've',
  'vg',
  'vi',
  'vn',
  'vu',
  'wf',
  'ws',
  'xk',
  'ye',
  'za',
  'zm',
  'zw',
] as const;
